import Vue from 'vue'

import Button from 'element-ui/lib/button'
import Form from 'element-ui/lib/form'
import FormItem from 'element-ui/lib/form-item'
import Input from 'element-ui/lib/input'
import Loading from 'element-ui/lib/loading'
import Message from 'element-ui/lib/message'
import Tabs from 'element-ui/lib/tabs'
import TabPane from 'element-ui/lib/tab-pane'
import Checkbox from 'element-ui/lib/checkbox'
import CheckboxGroup from 'element-ui/lib/checkbox-group'
import Dialog from 'element-ui/lib/dialog'
import Row from 'element-ui/lib/row'
import Col from 'element-ui/lib/col'
import Dropdown from 'element-ui/lib/dropdown'
import DropdownMenu from 'element-ui/lib/dropdown-menu'
import DropdownItem from 'element-ui/lib/dropdown-item'
import Popover from 'element-ui/lib/popover'
import Pagination from 'element-ui/lib/pagination'
import './element-style.scss'

Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Input)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Dialog)
Vue.use(Row)
Vue.use(Col)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Popover)
Vue.use(Pagination)
Vue.use(Loading.directive)

let plugins = {
  $loading: Loading.service,
  $message: Message,
}

Object.assign(Vue.prototype, plugins)

if (process.env.NODE_ENV === 'development') {
  Object.assign(window, plugins)
}
